import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default function removeByObjectValue( arr, key, val ) {
	return arr.filter( obj => getObjectValueByPath( obj, key ) !== val );
}
